import { useNavigate } from 'react-router';
import { gql, useQuery } from '@apollo/client';
import DropdownButton from './basics/DropdownButton';

const DropdownTeamsQuery = gql`
  query DropdownTeamsQuery {
    me {
      id
      teams {
        id
        name
      }
    }
  }
`;

const getOptions = (teams = []) => [
  { name: 'My Projects', path: '/app/my-projects' },
  { name: 'Shared with Me', path: '/app/shared-projects' },
  { divider: true, key: 'divider' },
  ...teams.map(({ id, name }) => ({
    name: `${name} Projects`,
    path: `/app/team/${id}/farms`,
  })),
];

const ProjectViewsDropdown = (props) => {
  const navigate = useNavigate();
  const { data } = useQuery(DropdownTeamsQuery);
  const teams = data?.me?.teams || [];
  return (
    <DropdownButton
      options={getOptions(teams)}
      setOption={(opt) => navigate(opt.path)}
      modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
      maxMenuHeight="60vh"
      {...props}
    />
  );
};

export default ProjectViewsDropdown;
